import { useState, useContext, useEffect } from "react";
import Context from "../../../context";

// Assets ------
import visa from "../../../assets/images/Visa.svg";
import mc from "../../../assets/images/Mastercard.svg";
import discover from "../../../assets/images/Discover.svg";
import amex from "../../../assets/images/Amex.svg";

import * as Icon from "react-bootstrap-icons";

import ModalButton from "../Modals/ModalButton";
import axios from "axios";
import { API_URL } from "../../data/constants";

const PaymentCard = ({
  isAutopay,
  cardData,
  canRemove,
  customerProfileId,
  setSelectedMethod,
}) => {
  const [defaultStatus, setDefaultStatus] = useState(false);
  const { contextState, setContextState } = useContext(Context);
  // const { cardId, cardType, cardNumber, cardNameFirst, cardNameLast, expirationDate } = cardData
  const cardMask = (
    <>
      &bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;&bull;&bull;&bull;&bull;&nbsp;
    </>
  );

  let cardActual = cardData.payment.item;
  let userRole = localStorage.getItem("userRole");
  
  /*const isDefault = (id) => {
    return contextState.defaultPayMethod.paymentId === id;
  };*/

  useEffect(() => {
    setDefaultStatus(cardData.isDefault);

    setDefaultMethod(
        cardData.customerPaymentProfileId,
        cardData.customerProfileId
    );
  }, [contextState.defaultPayMethod]);
 /* useEffect(()=>{
    setDefaultMethod(
      cardData.customerPaymentProfileId,
      cardData.customerProfileId
    );
  },[]);*/

  const cardTypes = {
    Visa: {
      fullname: "Visa",
      icon: visa,
    },
    MasterCard: {
      fullname: "Mastercard",
      icon: mc,
    },
    Discover: {
      fullname: "Discover",
      icon: discover,
    },
    AmericanExpress: {
      fullname: "American Express",
      icon: amex,
    },
  };

  const setDefaultMethod = (paymentId, customerId) => {
   /* setContextState((prevState) => ({
      ...prevState,
      defaultPayMethod: {
        type: "card",
        paymentId: paymentId,
        customerId: customerId,
      },
    }));*/

    setSelectedMethod &&
    setSelectedMethod({
      paymentProfileId: cardData.customerPaymentProfileId,
      customerProfileId: cardData.customerProfileId,
      isCard: cardData?.payment?.item?.accountNumber ? false : true
    });
  };

  return (
    <div
      className={`payment-card payment-card--alt${
        defaultStatus ? " selected" : ""
      }`}>
      <div className="payment-card--wrapper">
        <div className="d-flex justify-content-between mb-4">
          {cardTypes[cardActual.cardType]?.icon && (
            <div className="payment-card__icon">
              <img
                src={cardTypes[cardActual.cardType]?.icon}
                alt="Card Type Icon"
              />
            </div>
          )}

          {canRemove && (
            <ModalButton
              className="remove-card-btn"
              icon={<Icon.TrashFill height={14} width={14} />}
              modal="removePayment"
              payload={{
                customerId: cardData.customerId,
                customerProfileId: cardData.customerProfileId,
                customerPaymentProfileId: cardData.customerPaymentProfileId,
              }}>
              Remove
            </ModalButton>
          )}

          <div className="row flex-sm-nowrap"
               onClick={() => {
                 axios
                     .get(API_URL + `/Payments/DefaultProfile/${cardData.customerId}/${cardData.customerPaymentProfileId}/${userRole}`, {
                       headers: {
                         Authorization: `${localStorage.getItem("accessToken")}`,
                       },
                     })
                     .then((res) => {
                       setContextState({ ...contextState, paymentMethodsChanged: !contextState.paymentMethodsChanged });
                     })
                     .catch((err) => {
                       console.error(err);
                     })

                 setDefaultMethod(
                     cardData.customerPaymentProfileId,
                     cardData.customerProfileId
                 );
               }}>
            <div className="col-12 col-sm-auto">
              <div className="payment-card__selection">
                <div className={`radio${defaultStatus ? " selected" : ""}`}>
                  <div className="radio-input" />
                  <label className="radio-label">
                    {(isAutopay && "Use This Method") || "Default"}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="payment-card__info">
          <div className="row">
            <div className="col-6">
              <div className="payment-card__number mb-4">
                {cardMask}
                {!cardActual.accountNumber
                  ? cardActual.cardNumber.replaceAll("X", "")
                  : cardActual.accountNumber.replaceAll("X", "")}
              </div>
            </div>
            <div className="col-lg-6 text-lg-right">
              {cardActual.expirationDate && (
                <div className="payment-card__expiration mb-4">
                  Exp {cardActual.expirationDate}
                </div>
              )}
            </div>
          </div>
          <div className="row flex-sm-nowrap">
            <div className="col-12 col-sm">
              <div className="payment-card__name mb-4 mb-sm-0">
                {cardData.billTo?.firstName} {cardData.billTo?.lastName}
                &nbsp;{cardActual.nameOnAccount}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PaymentCards = ({
  isAutopay = false,
  canRemove,
  isGlobal = false,
  setSelectedMethod,
}) => {
  const { contextState, setContextState } = useContext(Context);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const account = contextState.currentAccount;
  let userRole = localStorage.getItem("userRole");
  
  useEffect(() => {
    setIsLoading(true);
    axios
      .post(
        API_URL + "/Payments/Profile",
        {
          customerId: (!isGlobal && account?.contract?.customerId) || null,
          customerNumber: (!isGlobal && account?.customerNumber) || null,
          masterCustomerId: null,
          userName: (isGlobal && localStorage.getItem("username")) || null,
          userRole: userRole
        },
        { headers: { Authorization: `${localStorage.getItem("accessToken")}` } }
      )
      .then((res) => {
        if (isGlobal) {
          setPaymentMethods(
            res.data
              .map((acct) => {
                return acct.profile?.paymentProfiles;
              })
              .flat()
          );
        } else {
          setPaymentMethods(res?.data[0]?.profile?.paymentProfiles);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [contextState.paymentMethodsChanged]);

  return (
    <>
      {isLoading ? (
          <div className="d-flex justify-content-center align-items-center">
            <div className="spinner-border mr-4" role="status"/>
            <h4>Loading Accounts...</h4>
          </div>
      ) : (
      <div className="payment-cards">
        <div className="row">
          {paymentMethods?.length > 0 ? (
            paymentMethods?.map((cardData, index) => (
              <div
                className="col col-md-6 col-lg-12 col-xl-6 col-xxl-auto"
                key={index}>
                <PaymentCard
                  isAutopay={isAutopay}
                  cardData={cardData}
                  canRemove={canRemove}
                  setSelectedMethod={setSelectedMethod}
                />
              </div>
            ))
          ) : (
            <h4 className="mx-auto">No existing forms of payment.</h4>
          )}
        </div>
      </div>
      )}
    </>
  );
};

export default PaymentCards;
